//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconPersonAdd(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M9 12C11.21 12 13 10.21 13 8C13 5.79 11.21 4 9 4C6.79 4 5 5.79 5 8C5 10.21 6.79 12 9 12ZM9 6C10.1 6 11 6.9 11 8C11 9.1 10.1 10 9 10C7.9 10 7 9.1 7 8C7 6.9 7.9 6 9 6Z" fill="currentColor" /><path d="M20 10V7H18V10H15V12H18V15H20V12H23V10H20Z" fill="currentColor" /><path d="M3.3 14L0.75 21H12.99L12.27 19H3.61L4.7 16H13.3L15.12 21H17.25L14.7 14H3.3Z" fill="currentColor" /></svg>;
}
export default IconPersonAdd;